// extracted by mini-css-extract-plugin
export default {"main-info-wrapper":"ZyEHG","title":"R31ri","header":"lzRmF","content":"UCCyi"};